/**
 * deployment-detection-view.js
 */

import React from 'react';
import { Box } from '@mui/material';
import { useParams } from "react-router-dom";
import { Types } from 'utils/constants';
import useRecordStore from 'contexts/record-store';
import ArrestsView from 'components/deployment/helpers/arrests-view';
import DetectionOdorsView from 'components/detection-odors/view';
import IconSection from 'components/icon-section';
import InfoRow from 'components/info-row';


export default function DeploymentDetectionView(props) {
  const { deployment } = props;
  const { deploymentId } = useParams();
  const recordStore = useRecordStore();
  const deploymentRecord = recordStore.useRecord(Types.Record.DEPLOYMENT, deploymentId).ornull;
  const detection = deploymentRecord.get()?.detection;


  return (
    <>
      {deploymentRecord && detection &&
        <>
          <IconSection iconName='environment'>
            {/* detection odors */}
            <DetectionOdorsView
              environments={detection.environments}
              recordType={Types.Record.DEPLOYMENT}
            />

            {/* detection misc */}
            {(detection.wasNotIndicatedCurrencyPresent || detection.didSubjectAdmitToPossession !== null) &&
              <Box mt={4} mb={1}>
                {detection.wasNotIndicatedCurrencyPresent &&
                  <InfoRow
                    title="Currency That Dog Did Not Alert To"
                    text={`${detection.notIndicatedCurrencyAmount} ${detection.notIndicatedCurrencyType?.name || ''}`}
                  />}

                {detection.didSubjectAdmitToPossession !== null &&
                  <InfoRow title="Alerts Without Items Seized" text={`There is ${detection.didSubjectAdmitToPossession ? '' : 'no '}independent information that a target odor is present`} />}
              </Box>
            }
          </IconSection>

          {detection.arrests?.length > 0 && 
          <IconSection iconName='patrol-arrests-bites'>
            <Box mb={3}>
              <InfoRow title="Dog-Assisted Arrests" text={detection.arrests.length} />
            </Box>

            <ArrestsView
              deployment={deployment}
              record={detection}
              workMode={Types.WorkMode.DETECTION}
            />
          </IconSection>}
        </>}
    </>
  );
}